import AxiosClient from "../../../services/axios.services";

class TipoCriticidadServices {
  getTipoCriticidad = (params) =>
    AxiosClient.get("/api/app/carrera_sucesion_tipo_criticidad/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveTipoCriticidad = (data) =>
    AxiosClient.post("/api/app/carrera_sucesion_tipo_criticidad/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTipoCriticidad = (id, data) =>
    AxiosClient.put(`/api/app/carrera_sucesion_tipo_criticidad/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteTipoCriticidad = (id) =>
    AxiosClient.delete(`/api/app/carrera_sucesion_tipo_criticidad/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TipoCriticidadServices();
